export default "__VITE_ASSET__BCyLHk6b__"